import React from 'react';

const Treneri = () => {
  return (
    <div className="razvojna-page">

      <h1>John Anderson - Transforming Lives Through Fitness</h1>
      <img src="https://example.com/john-anderson.jpg" alt="John Anderson" />

      <h2>Introduction:</h2>
      <p>
        Welcome to the biography page of John Anderson, a dedicated fitness coach who has been transforming lives through his passion for health and wellness. With years of experience and a deep understanding of the human body, John has empowered countless individuals to achieve their fitness goals, improve their overall well-being, and unlock their full potential. Join us as we delve into the remarkable journey of this inspiring fitness coach.
      </p>

      <h2>Early Life and Education:</h2>
      <p>
        Born and raised in a small town, John Anderson developed...
      </p>
      {/* Add more sections as needed */}

    </div>
  );
};

export default Treneri;
